var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.785,
    height: 17.119,
    viewBox: "0 0 14.785 17.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "word-file-svgrepo-com",
    d: "M8.447,1a.778.778,0,0,0-.55.228L3.228,5.9A.778.778,0,0,0,3,6.447v9.338a2.334,2.334,0,0,0,2.334,2.334H8.447a.778.778,0,0,0,0-1.556H5.334a.778.778,0,0,1-.778-.778V7.225H8.447a.778.778,0,0,0,.778-.778V2.556h5.447a.778.778,0,0,1,.778.778V7.225a.778.778,0,1,0,1.556,0V3.334A2.334,2.334,0,0,0,14.672,1ZM7.669,5.669H5.657L7.669,3.657ZM10.744,10.1a.778.778,0,1,0-1.482.476l1.751,5.447a.778.778,0,0,0,1.482,0l1.01-3.142,1.01,3.142a.778.778,0,0,0,1.482,0l1.751-5.447a.778.778,0,1,0-1.482-.476l-1.01,3.142L14.246,10.1a.778.778,0,0,0-1.482,0l-1.01,3.142Z",
    transform: "translate(-3 -1)",
    fill: "#3262BB",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWord);
export default __webpack_public_path__ + "static/media/icon-word.f1bfe7456ee89af899577d96d26ea4b6.svg";
export { ForwardRef as ReactComponent };